export default {
  en: {
    actions: {
      edit: 'Edit',
      withdraw_support: 'Withdraw support',
      delete: 'Delete',
    },
  },
};
